import { CoordinatorService } from './coordinator.service';
import { Report } from './report';
import { ScriptBase } from './script-base';
import { ScriptHitset } from './script-hitset';
import { FIRST_ARG, SELECTION_ROLE } from './script-types';
import { View } from './view';

export class ScriptSubset extends ScriptBase {
    #coords: CoordinatorService;
    #_view: View;

    constructor(coords: CoordinatorService, _view: View) {
        super(coords, _view);
        this.#coords = coords;
        this.#_view = _view;
    }

    get target() {
        return this.#_view;
    }

    private _newHitset(arg: FIRST_ARG) {
        if (this.#coords.utils$.hasHitset(arg)) {
            return arg.hitset();
        } else return this.#coords.script$.dataset().hitset();
    }

    addToReport(r: Report) {
        r.addSubsets(this.#_view);
    }

    add(h: FIRST_ARG) {
        if (!(h instanceof ScriptHitset)) h = this._newHitset(h);
        this.#_view.addIds(h.idSet);
        return this;
    }

    delete(deleteIfNotEmpty = false) {
        if (deleteIfNotEmpty === true || !this.#_view.size) this.#_view.delete();
    }

    remove(h: FIRST_ARG) {
        if (!(h instanceof ScriptHitset)) h = this._newHitset(h);
        this.#_view.deleteIds(h.idSet);
        return this;
    }

    overlap(oldH: FIRST_ARG) {
        if (!(oldH instanceof ScriptHitset)) oldH = this._newHitset(oldH);
        return this.hitset().overlap(oldH);
    }

    and(oldH: FIRST_ARG) {
        if (!(oldH instanceof ScriptHitset)) oldH = this._newHitset(oldH);
        return this.hitset().and(oldH);
    }

    or(oldH: FIRST_ARG) {
        if (!(oldH instanceof ScriptHitset)) oldH = this._newHitset(oldH);
        return this.hitset().or(oldH);
    }

    not(oldH: FIRST_ARG) {
        if (!(oldH instanceof ScriptHitset)) oldH = this._newHitset(oldH);
        return this.hitset().not(oldH);
    }

    display(isPreview = false) {
        this.hitset(isPreview).display();
        return this;
    }

    log(prefix = 'Subset') {
        console.log(`${prefix}: ${this.#_view.title}, SIZE: ${this.#_view.size}`);
        return this;
    }

    hitset(isPreview = false) {
        const nH = new ScriptHitset(this.#coords, isPreview);
        return this._hitset(nH, this.#_view.idSet);
    }

    json() {
        const dct = this.#_view.save() as any;
        delete dct.id;
        dct.items = dct.xitmIdLs;
        delete dct.xitmIdLs;
        return dct;
    }
}
